import { invert } from 'lodash'
// eslint-disable-next-line camelcase
import { $t_noop } from './i18n/helpers'
export const REDIRECT_DELAY = 5000
export const CLIENT_QUERY_TIMEOUT = 10000

export const STORAGE_COUNTRY_KEY = 'cobrand:country'

export const CARD_STATUS = Object.freeze({
  BOUND: 'bound',
  UNBOUND: 'unbound',
  PARTNER_BLOCK: 'partner_block'
})

export const GAMES = Object.freeze({
  MT: 'mt',
  MK: 'mk',
  TB: 'tb'
})

export const GAME_NAMES = Object.freeze({
  [GAMES.MT]: $t_noop('Мир танков'),
  [GAMES.MK]: $t_noop('Мир кораблей'),
  [GAMES.TB]: $t_noop('Tanks Blitz')
})

export const GAME_NAMES_SHORT = Object.freeze({
  [GAMES.MT]: 'Мир танков',
  [GAMES.MK]: 'Мир кораблей',
  [GAMES.TB]: 'Tanks Blitz'
})

export const CARD_TYPES = Object.freeze({
  mt_debit: 'mt_debit',
  mt_credit: 'mt_credit',
  blitz_debit: 'tb_debit',
  blitz_credit: 'tb_credit',
  mk_debit: 'mk_debit',
  mk_credit: 'mk_credit',
  WA: 'WA',
  WH: 'WH',
  WZ: 'WZ',
  WI: 'WI',
  WB: 'WB',

  // for support old card types in production
  WG: 'WG',
  WD: 'WD',
  WK: 'WK'
})

export const UNKNOWN_CARD_TYPE = 'UNKNOWN'

export const CARD_NAMES_BY_GAME = Object.freeze({
  [GAMES.MT]: $t_noop('Карта Мир танков'),
  [GAMES.MK]: $t_noop('Карта Мир кораблей'),
  [GAMES.TB]: $t_noop('Карта Tanks Blitz')
})

export const CARD_NAMES = Object.freeze({
  WA: $t_noop('Карта Мир танков'), // MT Standard card
  WH: $t_noop('Карта Мир танков'), // MT Branded card
  WZ: $t_noop('Карта Tanks Blitz'), // TB card
  WI: $t_noop('Карта Мир кораблей'), // MT card
  WB: $t_noop('Карта Lesta Games Premium') // Premium card
})

export const CARD_TYPES_BY_GAMES = Object.freeze({
  [GAMES.MT]: [CARD_TYPES.WA, CARD_TYPES.WH, CARD_TYPES.WB, CARD_TYPES.WD],
  [GAMES.MK]: [CARD_TYPES.WI, CARD_TYPES.WB, CARD_TYPES.WG],
  [GAMES.TB]: [CARD_TYPES.WZ, CARD_TYPES.WB, CARD_TYPES.WK]
})

export const AVAILABLE_COUNTRIES = {
  RU: [$t_noop('Россия'), $t_noop('России')],
  BY: [$t_noop('Беларусь'), $t_noop('Беларуси')]
}

// list of basic errors
export const ERRORS = {
  UNKNOWN_ERROR: {
    code: 'unknown_error',
    message: 'Неизвестная ошибка, повторите попытку позже.'
  },
  TIMEOUT_ERROR: {
    code: 'timeout_error',
    message: 'Превышено время ожидания, попробуйте ещё раз.'
  },
  SERVER_ERROR: {
    code: 'server_error',
    message: 'Сервер временно недоступен, повторите попытку позже.'
  },
  PARSE_RESPONSE_ERROR: {
    code: 'parse_response_error',
    message: 'Неверный ответ сервера'
  },
  ACCESS_DENIED: {
    code: 'access_denied'
  }
}

export const CURRENCIES = ['gold', 'doubloon']
export const VIRTUAL_CURRENCY_GROUP = 'virtual_currency'
export const BONUSES_GROUPS = ['booster']
export const PREMIUM_SHOP_GROUP = 'premium_shop_bonus'

export const gameNames = {
  GAME_ALL: 'all',
  GAME_MT: 'mt',
  GAME_MK: 'mk',
  GAME_TB: 'tb'
}

export const availableGames = [gameNames.GAME_MT, gameNames.GAME_MK, gameNames.GAME_TB]

export const gameTitles = {
  [gameNames.GAME_MT]: {
    name: $t_noop('Мир танков')
  },
  [gameNames.GAME_MK]: {
    name: $t_noop('Мир кораблей')
  },
  [gameNames.GAME_WOWP]: {
    name: $t_noop('World of Warplanes')
  },
  [gameNames.GAME_TB]: {
    name: $t_noop('Tanks Blitz')
  }
}

const BOOSTERS_DESCRIPTION = $t_noop('Дополнительных бонусов с картой каждый месяц')

export const BOOSTERS_BENEFITS_BY_GAMES = {
  [GAMES.MT]: {
    RU: { value: '54+', description: BOOSTERS_DESCRIPTION },
    BY: { value: '54+', description: BOOSTERS_DESCRIPTION }
  },
  [GAMES.MK]: {
    RU: { value: '120+', description: BOOSTERS_DESCRIPTION },
    BY: { value: '120+', description: BOOSTERS_DESCRIPTION }
  }
}

const BONUS_BENEFIT = {
  value: 5,
  description: $t_noop('Бонус за покупки в Премиум магазине')
}

export const BONUS_BENEFITS_BY_GAMES = {
  [GAMES.MT]: {
    RU: BONUS_BENEFIT,
    BY: BONUS_BENEFIT
  },
  [GAMES.MK]: {
    RU: BONUS_BENEFIT,
    BY: BONUS_BENEFIT
  },
  [GAMES.TB]: {
    RU: BONUS_BENEFIT,
    BY: BONUS_BENEFIT
  }
}

export const PARTNERS = {
  ALFABANK_BY: 'alfa_by',
  ALFA_BY: 'alfabankby',
  TBANK: 'tinkoff',
  WG_TBANK: 'wg_tinkoff'
}

export const PARTNERS_TAG = {
  [PARTNERS.ALFA_BY]: 'alfa',
  [PARTNERS.ALFABANK_BY]: 'alfa',
  [PARTNERS.TBANK]: 'tbank'
}

export const PARTNERS_TAG_TO_NAME = {
  [PARTNERS_TAG[PARTNERS.ALFA_BY]]: PARTNERS.ALFA_BY,
  [PARTNERS_TAG[PARTNERS.ALFABANK_BY]]: PARTNERS.ALFABANK_BY,
  [PARTNERS_TAG[PARTNERS.TBANK]]: PARTNERS.TBANK,
  [PARTNERS_TAG[PARTNERS.WG_TBANK]]: PARTNERS.WG_TBANK
}

const ALFA_PARTNER_DATA = {
  depositUrl: 'https://perevod.alfabank.by',
  rulesUrl: '/rules/ab',
  bankSupportUrl: 'https://www.alfabank.by/about/contact-center/ ',
  label: $t_noop('Альфа Банк')
}

const TBANK_PARTNER_DATA = {
  depositUrl: 'https://www.tbank-online.com/cardtocard/',
  rulesUrl: '/rules/tbank',
  bankSupportUrl: 'https://www.tbank-online.com/',
  label: $t_noop('Т-Банк')
}

export const PARTNER_DATA_BY_NAME = {
  [PARTNERS.ALFABANK_BY]: ALFA_PARTNER_DATA,
  [PARTNERS.ALFA_BY]: ALFA_PARTNER_DATA,
  [PARTNERS.TBANK]: TBANK_PARTNER_DATA,
  [PARTNERS.WG_TBANK]: TBANK_PARTNER_DATA
}

export const AVAILABLE_PARTNERS = {
  RU: [PARTNERS_TAG[PARTNERS.TBANK]],
  BY: [PARTNERS_TAG[PARTNERS.ALFABANK_BY]]
}

export const DEFAULT_PARTNER_FOR_COUNTRY = {
  RU: PARTNERS_TAG[PARTNERS.TBANK],
  BY: PARTNERS_TAG[PARTNERS.ALFABANK_BY]
}

export const DEFAULT_PARTNER_NAME_FOR_COUNTRY = {
  RU: PARTNERS.TBANK,
  BY: PARTNERS.ALFABANK_BY
}

export const ERROR_CODES_MESSAGES = {
  404: $t_noop('Страница не найдена'),
  500: $t_noop('На серевере произошла непредвиденная ошибка, пожалуйста подождите и она будет исправлена'),
  503: $t_noop('Сервер временно недоступен. Повторите попытку позже')
}

export const VALIDATION_ERRORS = {
  ENTITY_NOT_FOUND: 'entity_not_found',
  CODE_ALREADY_USED: 'code_already_used',
  CODE_ALREADY_BOUND: 'code_already_bound',
  BANK_ACCOUNT_NOT_FOUND_BY_EAN: 'bank_account_not_found_by_ean'
}

export const CARD_HOST = `https://card.lesta.ru`
export const LEGAL_HOST = `https://legal.lesta.ru`
export const HOST = 'https://lesta.ru'
export const MT_HOST = 'https://tanki.su/'
export const MK_HOST = 'https://korabli.su/'
export const TB_HOST = 'https://tanksblitz.ru/'

export const SUPPORT_PORTAL_LINK_URL = `${HOST}/support/`
export const PRIVACY_POLICY_LINK_URL = `${LEGAL_HOST}/privacy-policy/`

export const RANDOM_REWARDS_DATA_STATUS = {
  NEED_AUTH: 'NEED_AUTH',
  NEED_PARTICIPATE: 'NEED_PARTICIPATE',
  DATA_NOT_READY: 'DATA_NOT_READY',
  DATA_READY: 'DATA_READY'
}

export const QUEST_CODE_SELECT = {
  TINKOFF_DLR: 'TINKOFF_DLR',
  TINKOFF_UTL: 'TINKOFF_UTL',
  TINKOFF_SUM: 'TINKOFF_SUM',
  TINKOFF_BAF: 'TINKOFF_BAF',
  TINKOFF_LST: 'TINKOFF_LST',
  MT_BATTLES: 'MT_BATTLES',
  MT_WINS: 'MT_WINS',
  TB_BATTLES: 'TB_BATTLES',
  TB_WINS: 'TB_WINS',
  SOCIAL_SHARE: 'SOCIAL_SHARE',
  QUIZ_FINISH: 'QUIZ_FINISH'
}

export const RANDOM_BUTTON_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  FINISH: 'finish'
}

export const GAME_TO_COLORS = {
  [GAMES.MT]: '#FF8000',
  [GAMES.TB]: '#FFC101',
  [GAMES.MK]: '#94B0CD'
}

export const ATTENTION_COLOR = '#FF002A'

export const ROUTE_GAME_MAP = {
  mt: 'mt',
  mk: 'mk',
  tb: 'tb'
}

export const GAME_ROUTE_MAP = invert(ROUTE_GAME_MAP)

export const ACCOUNT_QUERY_KEY = 'acc_id'
